import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

export const legalEstateFieldPack: FieldPack = {
  id: 'genogram-legal-estate',
  name: 'Legal & Estate Planning',
  description: 'Fields for legal status, estate planning, and financial information',
  version: '1.0.0',
  dependencies: ['genogram-base'],
  fields: [
    {
      id: 'legalStatus',
      label: 'fields.legal.legalStatus.label',
      description: 'fields.legal.legalStatus.description',
      type: FieldType.SELECT,
      tags: ['legal', 'estate'],
      priority: 95,
      options: [
        { value: 'competent', label: 'fields.legal.legalStatus.options.competent' },
        { value: 'minor', label: 'fields.legal.legalStatus.options.minor' },
        { value: 'guardian', label: 'fields.legal.legalStatus.options.guardian' },
        { value: 'conservatorship', label: 'fields.legal.legalStatus.options.conservatorship' },
        { value: 'incapacitated', label: 'fields.legal.legalStatus.options.incapacitated' },
      ],
      namespace: 'legal',
    },
    {
      id: 'guardianship',
      label: 'fields.legal.guardianship.label',
      description: 'fields.legal.guardianship.description',
      type: FieldType.TEXT,
      tags: ['legal', 'estate'],
      priority: 90,
      placeholder: 'fields.legal.guardianship.placeholder',
      namespace: 'legal',
    },
    {
      id: 'powerOfAttorney',
      label: 'fields.legal.powerOfAttorney.label',
      description: 'fields.legal.powerOfAttorney.description',
      type: FieldType.SELECT,
      tags: ['legal', 'estate'],
      priority: 85,
      options: [
        { value: 'none', label: 'fields.legal.powerOfAttorney.options.none' },
        { value: 'healthcare', label: 'fields.legal.powerOfAttorney.options.healthcare' },
        { value: 'financial', label: 'fields.legal.powerOfAttorney.options.financial' },
        { value: 'both', label: 'fields.legal.powerOfAttorney.options.both' },
      ],
      namespace: 'legal',
    },
    {
      id: 'advanceDirectives',
      label: 'fields.legal.advanceDirectives.label',
      description: 'fields.legal.advanceDirectives.description',
      type: FieldType.BOOLEAN,
      tags: ['legal', 'medical', 'health'],
      priority: 80,
      namespace: 'legal',
    },
    {
      id: 'willStatus',
      label: 'fields.legal.willStatus.label',
      description: 'fields.legal.willStatus.description',
      type: FieldType.SELECT,
      tags: ['legal', 'estate'],
      priority: 75,
      options: [
        { value: 'none', label: 'fields.legal.willStatus.options.none' },
        { value: 'draft', label: 'fields.legal.willStatus.options.draft' },
        { value: 'executed', label: 'fields.legal.willStatus.options.executed' },
        { value: 'trust', label: 'fields.legal.willStatus.options.trust' },
      ],
      namespace: 'legal',
    },
    {
      id: 'trustee',
      label: 'fields.legal.trustee.label',
      description: 'fields.legal.trustee.description',
      type: FieldType.TEXT,
      tags: ['legal', 'estate'],
      priority: 70,
      placeholder: 'fields.legal.trustee.placeholder',
      namespace: 'legal',
    },
    {
      id: 'executor',
      label: 'fields.legal.executor.label',
      description: 'fields.legal.executor.description',
      type: FieldType.TEXT,
      tags: ['legal', 'estate'],
      priority: 65,
      placeholder: 'fields.legal.executor.placeholder',
      namespace: 'legal',
    },
    {
      id: 'beneficiaries',
      label: 'fields.legal.beneficiaries.label',
      description: 'fields.legal.beneficiaries.description',
      type: FieldType.TEXT,
      tags: ['legal', 'estate'],
      priority: 60,
      multiline: true,
      placeholder: 'fields.legal.beneficiaries.placeholder',
      namespace: 'legal',
    },
    {
      id: 'assets',
      label: 'fields.legal.assets.label',
      description: 'fields.legal.assets.description',
      type: FieldType.MULTI_SELECT,
      tags: ['financial', 'economic'],
      priority: 55,
      allowCustomOptions: true,
      options: [
        { value: 'real_estate', label: 'fields.legal.assets.options.real_estate' },
        { value: 'business', label: 'fields.legal.assets.options.business' },
        { value: 'investments', label: 'fields.legal.assets.options.investments' },
        { value: 'retirement', label: 'fields.legal.assets.options.retirement' },
        { value: 'life_insurance', label: 'fields.legal.assets.options.life_insurance' },
      ],
      namespace: 'legal',
    },
    {
      id: 'debts',
      label: 'fields.legal.debts.label',
      description: 'fields.legal.debts.description',
      type: FieldType.MULTI_SELECT,
      tags: ['financial', 'economic'],
      priority: 50,
      allowCustomOptions: true,
      options: [
        { value: 'mortgage', label: 'fields.legal.debts.options.mortgage' },
        { value: 'loans', label: 'fields.legal.debts.options.loans' },
        { value: 'credit_card', label: 'fields.legal.debts.options.credit_card' },
        { value: 'medical', label: 'fields.legal.debts.options.medical' },
        { value: 'business', label: 'fields.legal.debts.options.business' },
      ],
      namespace: 'legal',
    },
    {
      id: 'legalNotes',
      label: 'fields.legal.legalNotes.label',
      description: 'fields.legal.legalNotes.description',
      type: FieldType.RICH_TEXT,
      tags: ['notes', 'documentation'],
      priority: 45,
      multiline: true,
      placeholder: 'fields.legal.legalNotes.placeholder',
      namespace: 'legal',
    },
  ],
};
